/* Two fixed presentations. The grid and time scale never undergo a transform. */
.fleet-perspective-viewport [data-fleet-timeline-rows-canvas] { scrollbar-gutter: stable; }
.fleet-perspective-active [data-fleet-timeline-rows-canvas] { row-gap: 1px; }
.fleet-perspective-active [data-fleet-timeline-row]:has(.fleet-timeline-segment) {
  padding-top: calc(1px + var(--fleet-stack-clearance, 0px));
  padding-bottom: 1px;
  transition: none;
}
.fleet-perspective-active [data-fleet-timeline-track]:has(.fleet-timeline-segment) { min-height: 30px; }
.fleet-perspective-active [data-fleet-timeline-track]:not([data-fleet-timeline-extra-lane]):has(.fleet-timeline-segment) { height: 30px; }
.fleet-perspective-active [data-fleet-timeline-row]:has(.fleet-timeline-segment) :is([data-fleet-truck-identity], [data-evening-truck-identity]) { padding-block: 0; }
.fleet-perspective-active .fleet-timeline-segment {
  top: 2px;
  height: 24px;
  overflow: visible;
  z-index: auto !important;
  border-radius: 4px;
  border-color: color-mix(in srgb, currentColor 36%, transparent);
  box-shadow: inset 0 1px 0 #ffffffad, 0 5px 0 -1px color-mix(in srgb, currentColor 30%, #cbd5e1),
    0 6px 3px -2px #0f172a30;
  transition: none;
  animation: none;
  filter: none;
  cursor: pointer;
}
/* A painted front face supplies the depth, without a 3D rendering context. */
.fleet-perspective-active .fleet-timeline-segment::before {
  content: "";
  position: absolute;
  z-index: 0;
  top: calc(100% - 2px);
  left: -1px;
  right: -1px;
  height: 6px;
  border: 1px solid color-mix(in srgb, currentColor 36%, transparent);
  border-top: 0;
  border-radius: 0 0 4px 4px;
  background: inherit;
  box-shadow: inset 0 8px #0f172a35;
  pointer-events: none;
}
.fleet-perspective-active .fleet-timeline-segment::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(180deg, #ffffff48, #ffffff00 55%, #0f172a0d);
  pointer-events: none;
}
.fleet-perspective-active .fleet-timeline-segment [data-fleet-timeline-segment-copy] {
  overflow: hidden;
  font-size: 11px;
}
.fleet-perspective-active .fleet-timeline-segment [data-fleet-status-markers],
.fleet-perspective-active .fleet-timeline-segment [data-fleet-context-badge],
.fleet-perspective-active .fleet-timeline-segment [data-fleet-product-badge],
.fleet-perspective-active .fleet-timeline-segment [data-fleet-priority-badge] { display: none; }

.fleet-perspective-stack {
  position: absolute;
  z-index: 30;
  left: 50%;
  top: 10px;
  width: 0;
  height: 0;
}
.fleet-perspective-panels {
  position: absolute;
  left: var(--fleet-stack-shift, 0px);
  bottom: calc(4px + var(--fleet-stack-lift, 0px));
  width: 20px;
  height: 20px;
  transform: translateX(-50%);
  background: linear-gradient(#64748b, #64748b) center / 2px 100% no-repeat;
}
.fleet-perspective-active .fleet-timeline-segment .fleet-timeline-sequence-badge { height: 22px; }
/* Réel Geotab : le trait et l'avancement restent sur la face avant ; les écarts passent sous le segment. */
.fleet-perspective-active [data-geotab-real-line] { top: 26px; height: 4px; }
.fleet-perspective-active [data-geotab-real-skip] { top: 2px; height: 28px; }
.fleet-perspective-active [data-geotab-real-progress] { top: 20px; }
.fleet-perspective-active [data-geotab-real-gap] { top: 32px; }
.fleet-perspective-active [data-fleet-timeline-track]:has([data-geotab-real-gap]) { margin-bottom: 20px; }
/* Le ✓ est réduit dans la vue à plat seulement ; la vue inclinée garde sa taille d'origine. */
.fleet-perspective-active [data-geotab-real-progress] {
  min-width: 15px;
  height: 0.9375rem;
  padding-inline: 0.1875rem;
  border-width: 1.5px;
  font-size: 0.62rem;
}
.fleet-perspective-panel,
.fleet-perspective-ribbon {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-width: 20px;
  max-width: var(--fleet-track-width);
  min-height: 20px;
  border-radius: 4px;
  background: white;
  box-shadow: 0 1px 2px #0f172a26, 0 3px 5px #0f172a24;
}
.fleet-perspective-active .fleet-perspective-panels [data-fleet-status-markers],
.fleet-perspective-active .fleet-perspective-panels [data-fleet-context-badge],
.fleet-perspective-active .fleet-perspective-panels [data-fleet-product-badge],
.fleet-perspective-active .fleet-perspective-panels [data-fleet-priority-badge] { display: flex; }
.fleet-perspective-panel > span { max-width: inherit; }
.fleet-perspective-panels [data-fleet-status-markers] > span,
.fleet-perspective-panels [data-fleet-context-badge],
.fleet-perspective-panels [data-fleet-product-badge] > span,
.fleet-perspective-panels [data-fleet-priority-badge] {
  width: auto;
  height: auto;
  min-width: 20px;
  max-width: var(--fleet-track-width);
  min-height: 20px;
  padding: 0 3px;
  font-size: 10px;
  line-height: 1;
  white-space: normal;
  overflow-wrap: anywhere;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fleet-perspective-panels [data-fleet-status-markers] > span,
.fleet-perspective-panels [data-fleet-context-icon] {
  padding: 0;
  width: 20px;
  height: 20px;
}
.fleet-perspective-panel svg { width: 14px; height: 14px; }
/* Le soleil couchant a plus de marge interne que le bouclier : même poids visuel à 18 px. */
.fleet-perspective-panel svg.fleet-pm-sunset-icon { width: 18px; height: 18px; }
.fleet-perspective-ribbon > span {
  position: static;
  transform: none !important;
  min-width: 0;
  max-width: inherit;
  min-height: 20px;
  padding: 0 4px;
  font-size: 10px;
  white-space: normal;
  overflow-wrap: anywhere;
}
.fleet-perspective-viewport[data-view-gesture="true"],
.fleet-perspective-viewport[data-view-gesture="true"] * { cursor: ns-resize !important; user-select: none; }

@media (prefers-reduced-motion: reduce) {
  .fleet-perspective-active *, .fleet-perspective-controls * { animation: none !important; transition: none !important; }
}
